<template>
  <div class="rewards-card">
    <span
      v-if="!selectedRewards.length"
      class="gray--text"
    >
      Selecione pelo menos 1 item para continuar
      <span class="red--text">*</span>
    </span>
    <div class="rewards-card-list">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="{'is-active-item': isSelectedItem(item)}"
        @click="$emit('select-reward', item)"
        class="rewards-card-list-item"
      >
        <div>
          <img
            :src="item.img"
            width="50"
            class="mb-2"
          >
        </div>
        <div
          :class="{ active: item.isActive }"
          class="icon-container"
        >
          <v-icon class="white--text mt-2 mb-2">
            workspace_premium
          </v-icon>
        </div>
        <p
          class="mt-2 mb-2 item-title"
          style="text-align: center"
        >
          {{ item.title }}
        </p>
        <span class="pl-3 pr-3 mt-2 trigger">
          {{ item.trigger }}
        </span>
      </div>
    </div>
    <div class="btn-container">
      <v-btn
        :disabled="disabledButton"
        @click="$emit('rescue-rewards')"
        class="white--text"
        color="primary"
      >
        RESGATAR BENEFÍCIOS
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RewardsCard',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectedRewards: {
      type: Array,
      default: () => []
    },
    disabledButton: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    isSelectedItem(item) {
      return this.selectedRewards.some(elem => elem._id === item._id)
    }
  }
}
</script>

<style lang="stylus">
.rewards-card
  padding: 0 60px;
  &-list
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    &-item
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      max-width: 195px;
      min-width: 195px;
      height: 260px;
      border: 2px solid #E0E0E0;
      border-radius: 8px;
      margin: 15px 10px;
      .item-title
        min-height: 40px;
      @media (max-width: 768px) {
        max-width: 125px;
        min-width: 125px;
      }
      .icon-container
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #E0E0E7;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      .active
        background-color: #3A7B80;
      @media(max-width: 1100px)
        margin: 15px;
      p
        font-weight: 600;
        font-size: 14px;
      .trigger
        background-color: #299D8D;
        color: #fff;
        border-radius: 20px;
    .is-active-item
      border: 2px solid #299D8D;
  .btn-container
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
</style>
